import React from 'react';
import { Button } from 'react-bootstrap';
import { SortableElement } from 'react-sortable-hoc';
import PropTypes from 'prop-types';

import SortHandle from './Handle';

const SortRow = ({ access, item, onEdit }) => (
  <tr className="signup-list__item">
    <td className="item__handle">
      {access?.signup_sort && !item?.is_default ? <SortHandle /> : null}
      <span>{item.title}</span>
    </td>
    <td className="item__name">
      <span>{item.required ? 'Required' : ''}</span>
    </td>
    <td className="item__actions p-r">
      {access?.signup_edit && !item?.is_default ? (
        <Button bsSize="xsmall" className="pull-right" onClick={() => onEdit(item)}>
          Edit
        </Button>
      ) : null}
    </td>
  </tr>
);

SortRow.propTypes = {
  access: PropTypes.object,
  item: PropTypes.object,
  onEdit: PropTypes.func,
};

export default SortableElement(SortRow);
